export default "__VITE_ASSET__73743703__"